import { useRef } from "react";
import { read, utils } from "xlsx";

const UploadForm = ({ handleUpload }) => {
  const formRef = useRef();
  const btnRef = useRef();

  const parseExcelFile = (result) => {
    const workbook = read(result);
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const data = utils.sheet_to_json(sheet);

    handleUpload(data);
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const fileReader = new FileReader();
    const { excel } = formRef.current;
    const file = excel.files[0];

    fileReader.readAsArrayBuffer(file);

    fileReader.onload = () => {
      parseExcelFile(fileReader.result);
    }
  };

  return (
    <form ref={formRef} onSubmit={(e) => handleSubmit(e)} style={{ position: "absolute", zIndex: -1 }}>
      <input type="file" name="excel" className="event__upload--input" onChange={(e) => {
        if (e.target.value) btnRef.current.click();
      }} />
      <button ref={btnRef} />
    </form>
  )
};

export default UploadForm;